 <bzg-modal-header>
      <h4>{{ data.title | translate | uppercase }}</h4>
    </bzg-modal-header>
    <bzg-modal-content class="">
      <span [innerHTML]="data.message | translate"></span>
    </bzg-modal-content>
    <bzg-modal-footer class="">
      <bzg-button-primary (click)="close()">{{ 'GLOBAL.CLOSE' | translate}}</bzg-button-primary>
    </bzg-modal-footer>
